import { StyleSheet } from 'react-native';

export const SparkLineStyling = theme => {
  return StyleSheet.create({
    container: {
      borderWidth: 4,
      borderColor: '#EBEEF2'
    },
    innerContainer: {
      borderWidth: 1,
      borderColor: '#DDE1E5'
    },
    chartContainer: {
      padding: 12,
      borderBottomWidth: 1,
      borderColor: '#DDE1E5'
    },
    dataContainer: {
      padding: 12
    },
    dataFlexContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 5
    },
    dataMicroText: {
      marginBottom: 4
    }
  });
};
export const LineCompStyling = theme => {
  return StyleSheet.create({
    sparkLineContainer: {
      flexDirection: 'row',
      overflow: 'auto',
      gap: 10
    },
    container: {
      borderWidth: 4,
      borderColor: '#DDE1E5'
    }
  });
};

export const tooltipStyling = {
  display: 'flex',
  marginBottom: '10px',
  gap: '20px',
  justifyContent: 'space-between'
};
